import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';

// services
import { AuthHttpInterceptor } from '../auth/auth.http.interceptor';
import { FavoritesService } from './favorites.service';

@NgModule({
  imports: [HttpClientModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
  ],
})
export class FavoritesServiceModule {
  static forRoot(): ModuleWithProviders<FavoritesServiceModule> {
    return {
      ngModule: FavoritesServiceModule,
      providers: [FavoritesService],
    };
  }
}
